export const renderLabel = <T>(item: T, index: keyof T) => item[index];
export const itemIdentifier = <T, K extends unknown = string>(
  item: T,
  index: keyof T
) => item[index] as K;
